// extracted by mini-css-extract-plugin
export default {"gradientAccent":"GradientAccent_gradientAccent__XgYKi","fixed":"GradientAccent_fixed__w6HvG"};